'use client'

import { HelpCircleIcon } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

/**
 * Small help icon that reveals explanatory text on hover — or on tap on a touch screen (see
 * tooltip.tsx). Safe inside a <label>: the click is kept from focusing the labelled field.
 */
export function InfoTip({ text }: { text: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className="text-foreground/30 hover:text-foreground/60 inline-flex cursor-help"
          onClick={(event) => event.preventDefault()}
        >
          <HelpCircleIcon className="size-3" />
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-72 text-xs leading-snug whitespace-pre-line">
        {text}
      </TooltipContent>
    </Tooltip>
  )
}
